import Havena1 from "./8x15 (1).webp";
import Havena2 from "./8x15 (2).webp";
import Havena3 from "./8x15 (3).webp";
import Havena4 from "./8x15 (4).webp";
import Havena5 from "./8x15 (5).webp";

const Havena8images = [Havena1, Havena2, Havena3, Havena4, Havena5];

export default Havena8images;
